<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Gestão do Grupo SCFV") }}
        {{ $t("ID") }} #{{ item.id }}
      </h1>
    </div>
    <load v-if="loading" />
    <div v-else class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <Header :item="item" />
        </div>
      </div>
      <div class="row">
        <Sidebar @page="showPage" :auditoria="item.auditoria" />
        <div class="col-md-9">
          <div v-if="page == 'scfv'">
            <div v-if="historicoStatus == false" class="card mb-0 shadow">
              <div class="card-body">
                <div class="tab-content">
                  <div class="animate__animated animate__fadeIn">
                    <div class="row">
                      <form-input
                        v-model="item.nome_grupo"
                        grid="6"
                        label="Nome do Grupo"
                        :required="true"
                      />
                      <form-select
                        v-model="item.faixa_etaria"
                        grid="6"
                        label="Faixa Etária"
                        :itens="$root.arrays.scfv_faixa_etaria"
                        :required="true"
                      />
                      <form-select
                        v-model="item.acesso"
                        grid="3"
                        label="Acesso"
                        :itens="$root.arrays.scfv_acesso"
                      />
                      <form-select
                        v-model="item.periodicidade"
                        grid="3"
                        label="Periodicidade"
                        :itens="$root.arrays.scfv_periodicidade"
                        :required="true"
                      />

                      <form-select
                        v-model="item.dias_semana"
                        grid="6"
                        label="Dia(s) da Semana"
                        :itens="$root.arrays.scfv_dias_semana"
                        :required="true"
                        :multiple="true"
                      />

                      <form-calendar
                        v-model="format_hora"
                        grid="4"
                        label="Horário"
                        mode="time"
                      />
                      <form-input
                        v-model="item.numero_vagas"
                        type="number"
                        grid="4"
                        label="Vagas"
                        :min="3"
                      />

                      <form-input
                        v-model="item.carga_horaria"
                        type="number"
                        grid="4"
                        label="Carga Horária"
                        :required="true"
                        :min="1"
                      />

                      <form-select
                        v-model="item.carater"
                        grid="6"
                        label="Caráter"
                        :itens="$root.arrays.scfv_carater"
                      />

                      <form-select
                        v-model="item.forma_execucao"
                        grid="6"
                        label="Forma de Execução"
                        :itens="$root.arrays.scfv_execucao"
                        @change="formaExecucao"
                      />

                      <form-select
                        v-model="item.unidade_osc_id"
                        grid="12"
                        label="Selecione uma OSC"
                        :itens="unidades"
                        v-if="campoExtra == true"
                      />

                      <form-select
                        v-model="item.unidade_base_id"
                        grid="6"
                        label="Base Física das Atividades"
                        :itens="unidades"
                        :required="true"
                      />

                      <form-select
                        v-model="item.tecnico_id"
                        grid="6"
                        label="Técnico de Referência"
                        :itens="tecnicos"
                        :required="true"
                      />

                      <form-select
                        v-model="item.orientador_id"
                        grid="6"
                        label="Orientador Social"
                        :itens="tecnicos"
                        :required="true"
                      />

                      <form-select
                        v-model="item.facilitador_id"
                        grid="6"
                        label="Facilitador de Oficinas"
                        :itens="tecnicos"
                      />
                      <label class="d-block font-weight-bold pl-3 mt-2"
                        >Selecione o(s) técnico(s) participante(s)</label
                      >
                    </div>
                    <search-tecnico :tecnicos.sync="item.tecnicos" col="6" />
                    <div class="row">
                      <form-textarea-editor
                        v-model="item.observacoes"
                        label="Objetivos"
                        :required="true"
                      />

                      <form-select
                        @change="verificarStatus"
                        v-model="item.status"
                        label="Status"
                        grid="4"
                        :itens="status"
                      />

                      <form-file
                        grid="8"
                        @submit="submitFile"
                        multiple
                        btn-text="Iniciar"
                        :progress="progressCompleted"
                      />
                    </div>
                    <div class="row pt-4 px-0 d-flex justify-content-end">
                      <div class="col-auto px-2 text-right">
                        <a
                          class="router-link-exact-active active px-3"
                          @click="historicoStatus = true"
                        >
                          <i class="fas fa-history"></i> Histórico de Status
                        </a>
                        <router-link
                          to="/dashboard/scfv/"
                          class="btn btn-default"
                        >
                          <i class="mdi mdi-arrow-left" />
                        </router-link>
                        <b-button
                          :title="$t('Visualizar e Imprimir')"
                          :to="'/dashboard/scfv/show/' + item.id"
                          class="py-1"
                          size="sm"
                          type="button"
                          v-b-tooltip.hover
                          variant="primary"
                        >
                          <i class="mdi mdi-printer mdi-18px" />
                        </b-button>
                        <button
                          class="btn btn-success btn-submit"
                          data-style="zoom-in"
                          type="submit"
                          @click="submit"
                        >
                          <i class="mdi mdi-content-save" />
                          {{ $t("Salvar") }}
                        </button>
                      </div>
                    </div>
                    <div v-if="item.anexos">
                      <anexos :anexos="item.anexos" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0 shadow card-body" v-else>
              <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">Grupo SCFV</h4>
                    </div>
                    <HistoricoStatus
                      @voltar="historicoStatus = false"
                      :id="item.id"
                      :familia="0"
                      :status="status_item"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <UsuariosVinculado :item="item" v-if="page == 'usuariosvinculado'" />

          <Atividade :item="item" v-if="page == 'atividade'" />

          <Encaminhamento :item="item" v-if="page == 'encaminhamento'" />
          <Logs :item="item" v-if="page == 'auditoria'" />

          <Comentario :item="item" v-if="page == 'comentario'" />

          <ParticipacoesAtividades
            :item="item"
            v-if="page == 'participacoes'"
          />
        </div>
      </div>
    </div>
    <status-historico
      :model="model"
      modulo="Scfv"
      titulo_modulo="SCFV"
      :id="item.id"
      :status-anterior="statusAnterior"
      :status-atual="statusAtual"
      :status="status_item"
      @submit="submit"
    />
  </div>
</template>
<script>
import { misMixins } from "./mixins.js";
import HistoricoStatus from "./HistoricoStatus";
import Header from "./Header";
import Sidebar from "./includes/Sidebar";
import Atividade from "./includes/abas/Atividade";
import Encaminhamento from "./includes/abas/Encaminhamento";
import UsuariosVinculado from "./includes/abas/UsuariosVinculado";
import Comentario from "./includes/abas/Comentario";
import Logs from "./includes/abas/Logs";
import ParticipacoesAtividades from "./includes/abas/ParticipacoesAtividades.vue";

export default {
  components: {
    HistoricoStatus,
    Header,
    Atividade,
    Encaminhamento,
    UsuariosVinculado,
    Sidebar,
    Comentario,
    Logs,
    ParticipacoesAtividades,
  },
  name: "Edit",
  data() {
    return {
      page: "scfv",
      loading: true,
      statusAtual: "",
      statusAnterior: "",
      historicoStatus: false,
      item: {
        lista_inscritos: [],
      },
      files: [],
      status: {},
      status_item: [],
      progressCompleted: 0,
      subtipoAtual: "",
      model: "ScfvGrupo",
      campoExtra: false,
      unidades: {},
      tecnicos: {},
      user_id: null,
      tecnico_id: null,
    };
  },
  mixins: [misMixins],
  mounted() {
    this.$root.$on("usuariosvinculado", () => {
      this.getItem();
    });
  },
  beforeDestroy() {
    this.$root.$off("usuariosvinculado");
  },
  methods: {
    calcularIdade(value) {
      var birthday = +new Date(value);
      return ~~((Date.now() - birthday) / 31557600000);
    },
    formaExecucao() {
      if (this.item.forma_execucao == 2) {
        this.campoExtra = true;
      } else {
        this.campoExtra = false;
      }
    },
    showPage(page) {
      this.page = page;
    },
    getItem() {
      this.loading = true;
      axios
        .get(`api/dashboard/scfv/${this.$route.params.id}`)
        .then((response) => {
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.user_id = this.$store.state.user.id;
          const dados = response.data.data;
          this.statusAnterior = dados.status;
          const user = this.$store.state.user;
          const isCoordenadorDaUnidade =
            user.role_details &&
            user.role_details.name == "Coordenador" &&
            user.tecnico &&
            user.tecnico.unidade_id == dados.unidade_id;

          if (
            isCoordenadorDaUnidade ||
            dados.user_id == this.user_id ||
            dados.tecnico_id == this.tecnico_id ||
            dados.orientador_id == this.tecnico_id ||
            dados.facilitador_id == this.tecnico_id ||
            this.isTecnicoParticipante(dados.tecnicos)
          ) {
            this.item = response.data.data;
            this.format_hora = response.data.data.horario;
          } else {
            swal.fire({
              title: "Ops!",
              html: "Apenas quem cadastrou, coordenador da unidade, técnico responsável, técnicos participantes, facilitador e orientador podem editar este grupo!",
              icon: "error",
            });
            this.$router.push("/dashboard/scfv");
          }
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        });
    },
    isTecnicoParticipante(tecnicos) {
      let user_logado = this.$store.state.user.tecnico.id;

      let is_tecnico = false;
      if (Array.isArray(tecnicos)) {
        tecnicos.forEach((id) => {
          if (id == user_logado) {
            is_tecnico = true;
          }
        });
      }
      return is_tecnico;
    },
    submit() {
      if (this.format_hora && this.format_hora != "") {
        this.item.horario = this.format_hora;
      }

      let formData = new FormData();

      if (this.files.length > 0 && this.files.length != undefined) {
        for (const i of Object.keys(this.files)) {
          formData.append("files[]", this.files[i]);
        }
      } else {
        formData.append("files", this.files);
      }
      if (
        this.item.tecnicos.length > 0 &&
        this.item.tecnicos.length != undefined
      ) {
        for (const i of Object.keys(this.item.tecnicos)) {
          formData.append("tecnicos[]", this.item.tecnicos[i]);
        }
      }
      for (var key in this.item) {
        formData.append(key, this.item[key]);
      }
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();
      axios
        .post(`api/dashboard/update/scfv`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          ladda.stop();
          this.item = response.data.data;
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        })
        .finally(() => {
          this.getItem();
          this.progressCompleted = 0;
          this.files = [];
        });
    },
  },
};
</script>
<style>
.router-link-exact-active {
  cursor: pointer;
}
</style>
